import { t } from 'i18next';
import * as yup from 'yup';

import { getEmptyErrorMessage } from 'core/yup';

export const schema = () =>
  yup.object().shape({
    corporateUser: yup
      .object()
      .nullable()
      .required(getEmptyErrorMessage(t('labelQuoteContact'))),
    externalCustomerNumber: yup
      .string()
      .label(t('labelCustomerNumber'))
      .nullable()
      .matches(/^\d{6}$/, {
        message: t('errorCustomerNumberDigitsOnly'),
        excludeEmptyString: true,
      }),
  });
